(() => {
  if (window.__heConversionEventsLoaded) return;
  window.__heConversionEventsLoaded = true;

  window.dataLayer = window.dataLayer || [];

  const push = (event, details = {}) => {
    window.dataLayer.push({ event, ...details });
  };

  document.addEventListener('click', (clickEvent) => {
    const target = clickEvent.target.closest('a, button');
    if (!target) return;

    const label = (target.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100);
    const href = target instanceof HTMLAnchorElement ? target.href : '';

    if (target.matches('[name="add"], .add-to-cart-button, .he-honey-card__add, .he-combo-card__add, .he-ccp__add')) {
      push('he_add_to_cart_click', { label, product_url: location.pathname });
      return;
    }

    if (target.matches('.he-product-whatsapp, [href*="wa.me"], [href*="whatsapp"]')) {
      push('he_whatsapp_click', { label, source_url: location.pathname });
      return;
    }

    if (target.matches('[name="checkout"], .cart__checkout-button, .he-direct-checkout__button, [href*="/checkout"]')) {
      push('he_checkout_click', { label, source_url: location.pathname });
      return;
    }

    if (href && /\/products\//.test(href)) {
      push('he_product_view_click', { label, destination: new URL(href).pathname, source_url: location.pathname });
    }
  });
})();
